module.exports = __webpack_public_path__ + "static/media/HP-Icon2-@2x.87907c83.png";